import { render } from "./service-view-component.vue?vue&type=template&id=41234a21&ts=true"
import script from "./service-view-component.vue?vue&type=script&lang=ts"
export * from "./service-view-component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__